import React from 'react';
import {TermsData, TermsDataPartTwo} from './TermsData';

function Terms(props) {
  return (
    <div className='idf-terms-container'>
        <span className='text-center agree-title'>ההתחייבות מול צה"ל</span>
      {Object.keys(TermsData).map((key) => {
        return (
          <div className='terms-section' key={key}>
            <p className='num'> {key}</p>
            <p className='text'> {TermsData[key]}</p>
          </div>
        );
      })}
      <span className='text-center agree-title'>ההתחייבות מול {window.Config.brand_Name_HE}</span>
      {Object.keys(TermsDataPartTwo).map((key) => {
        return (
          <div className={key != 1 ? 'terms-section subclause' : 'terms-section'} key={key}>
            <p className='num'> {key}</p>
            <p className='text'> {TermsDataPartTwo[key]}</p>
          </div>
        );
      })}
    </div>
  );
}

export default Terms;
